import type {Locale} from './locale';

/**
 * Локаль для ссылок на справочный центр b2b.telecom.kz.
 *
 * Портал ведёт справочный центр только на ru и kk — для /en/ismet-gid/*
 * он отдаёт 404, поэтому английский уводим на русскую версию.
 */
export function getHelpCenterLocale(locale: Locale | string): 'ru' | 'kk' {
    return locale === 'kk' ? 'kk' : 'ru';
}
